import React from 'react';
import ReactDOM from 'react-dom/client';
import AppRoot from './App.jsx';
import AppErrorBoundary from './components/AppErrorBoundary.jsx';
import { AuthProvider } from './contexts/AuthContext.jsx';
import { Toaster } from '@/components/ui/toaster';
import './i18n';
import './styles/tailwind.css';
import './styles/tokens.css';
import './styles.css';
import './styles-shell.css';
import './styles-dashboard.css';
import './styles-scheduler.css';
import './styles-screens.css';
import './styles-preview.css';
import './styles-content-improvements.css';
import './styles/shell.css';
import './styles/dashboard.css';
import './styles/library.css';
import './styles/post-preview.css';
import './styles/edit-post.css';
import './styles/settings.css';
import './styles/create-post.css';
import './styles/content-plan.css';
import './styles/edit-strategy.css';
import './styles/calendar.css';
import './styles/batch.css';
import './styles/auth.css';
import './styles/onboarding.css';
import './styles/assistant-fab.css';
import './styles/assistant.css';
import './styles/error-boundary.css';
import './styles/referrals.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AppErrorBoundary>
      <AuthProvider>
        <AppRoot />
        <Toaster />
      </AuthProvider>
    </AppErrorBoundary>
  </React.StrictMode>
);
